/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  margin-block-end: 0.25rem;
  box-sizing: border-box;
  display: block;
  background-color: transparent;
  font-size: var(--calcite-font-size--1);
  color: var(--calcite-color-text-2);
}
:host * {
  box-sizing: border-box;
}

:host(:last-child) {
  margin-block-end: 0px;
}

/* Shared styles for header elements */
.header {
  margin: 0px;
  display: flex;
  align-content: space-between;
  align-items: center;
  fill: var(--calcite-color-text-2);
  color: var(--calcite-color-text-2);
}

.heading {
  margin: 0px;
  padding: 0px;
  font-weight: var(--calcite-font-weight-medium);
}

.header .heading {
  flex: 1 1 auto;
  padding: 0.5rem;
}

.heading {
  margin-block: 0.5rem;
  margin-inline: 1rem;
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
  font-size: var(--calcite-font-size--1);
  line-height: 1.375;
  color: var(--calcite-color-text-3);
}

.container--indented {
  margin-inline-start: 1.5rem;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}